import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Hero from "./Hero";
import AboutMe from "./AboutMe";
import Projects from "./Projects";
import Navbar from "./NavBar";
import Preloader from "./Preloader";
import Contact from "./Contact";
import NotFound from "./NotFound"; // Import a 404 Not Found component

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Preloader />;
  }

  return (
    <Router basename="/my_portfolio"> {/* ✅ Set basename for deployment */}
      <Navbar />
      <div className="App">
        <Routes>
          <Route path="/" element={<Hero />} />
          <Route path="/about" element={<AboutMe />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} /> {/* ✅ Catch-all route */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
